/**
 * Common Sentry configuration for WP pages and ng-checkout.
 */
export const commonSentryConfig = {
  environment: process.env.SENTRY_ENVIRONMENT,
  dsn: 'https://9ea1a33f276705615ff0d80b1152fa64@o510915.ingest.us.sentry.io/4507606318841856',
  release: process.env.SENTRY_RELEASE,
  sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE),
  beforeSend(event) {
    event.tags = {
      ...event.tags,
      order_id: window?.localStorage?.getItem('transaction_id') || null,
    };

    return event;
  },
};
